// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  SignupRewardVerificationClaimData,
  SignupRewardVerificationClaimError,
  SignupRewardVerificationClaimResponse,
  SignupRewardVerificationCreateCheckoutData,
  SignupRewardVerificationCreateCheckoutError,
  SignupRewardVerificationCreateCheckoutResponse,
  SignupRewardVerificationGetStateData,
  SignupRewardVerificationGetStateError,
  SignupRewardVerificationGetStateResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Read independent pending/claimed reward items. This never evaluates signup risk or grants credits. When session_id is supplied, reward_type is required and the owned typed Session is reconciled with Stripe.
 */
export const signupRewardVerificationGetState = <ThrowOnError extends boolean = false>(
  options?: Options<SignupRewardVerificationGetStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    SignupRewardVerificationGetStateResponse,
    SignupRewardVerificationGetStateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/signup-reward-verification',
    ...options,
  });
};

/**
 * Create hosted test-mode Setup Checkout only for selected records with a persisted risk hit from Claim. The Session is bound to the logged-in user, reward type and those exact record IDs.
 */
export const signupRewardVerificationCreateCheckout = <ThrowOnError extends boolean = false>(
  options: Options<SignupRewardVerificationCreateCheckoutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SignupRewardVerificationCreateCheckoutResponse,
    SignupRewardVerificationCreateCheckoutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/signup-reward-verification/checkout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Evaluate server risk only when the logged-in user clicks the selected reward. A miss claims only that type. A hit persists its gate and returns requires_verification; create Checkout next. A returning Session may claim only the record IDs captured for its owner and reward type. Other rewards remain independent.
 */
export const signupRewardVerificationClaim = <ThrowOnError extends boolean = false>(
  options: Options<SignupRewardVerificationClaimData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    SignupRewardVerificationClaimResponse,
    SignupRewardVerificationClaimError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/credit/v1/signup-reward-verification/claim',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};
